import React from "react";
import ReactDOM from "react-dom/client";
import {RouterProvider} from "react-router-dom";
// web-vitals 3+ renamed get* → on* and replaced FID with INP (the new
// Core Web Vital that supersedes FID for interactivity). on* observers
// fire repeatedly across a page session; sendToGA dedups via the
// metric.name + metric.id channel that GA expects.
import {onCLS, onFCP, onINP, onLCP, onTTFB} from "web-vitals";
import {router} from "./Router";

// Expose the router instance for server-side Playwright render navigation.
// The /render/batch endpoint uses page.evaluate(() => window.__router.navigate(...))
// to trigger SPA navigation on warm pages without a full page reload.
window.__router = router;

// Render-ready signal — set to true by App.js when scene data is loaded and
// templates are mounted. The /render/batch endpoint polls this via
// page.waitForFunction(() => window.__renderReady).
window.__renderReady = false;

// Send Core Web Vitals to Google Analytics via GTM
function sendToGA(metric) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "web_vitals",
    metric_name: metric.name,
    metric_value: Math.round(metric.value),
    metric_rating: metric.rating, // "good" | "needs-improvement" | "poor"
  });
}

onCLS(sendToGA);
onFCP(sendToGA);
onINP(sendToGA);
onLCP(sendToGA);
onTTFB(sendToGA);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
